// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member-benefit[data-v-7ddbbf3f] {\n  width: 500px;\n}\n.member-benefit .card-header[data-v-7ddbbf3f] {\n  font-size: 18px;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
